// "Peinture et ingrédients" is recognised by name, with the same rule as the backend and the PDFs:
// the quote's free line by its designation, and the products consumed partially (stocked and used
// in g, ml, sprays, discs...) by their family's name.
const normalize = (text) => (text ?? "")
  .normalize("NFD").replace(/\p{Diacritic}+/gu, "")
  .toLowerCase().replace(/\s+/g, " ").trim();

export const isPeintureDesignation = (designation) => normalize(designation) === "peinture et ingredients";

export const isPeintureProduct = (product) => isPeintureDesignation(product?.family?.name);

// Mirrors the backend ConsumptionUnit: g and ml take decimals, the other units are counted
export const CONSUMPTION_UNITS = [
  { value: "G", label: "g", decimal: true },
  { value: "ML", label: "ml", decimal: true },
  { value: "SPRAY", label: "spray", decimal: false },
  { value: "FEUILLE", label: "feuille", decimal: false },
  { value: "PIECE", label: "pièce", decimal: false },
  { value: "CARTE", label: "carte", decimal: false },
  { value: "DISQUE", label: "disque", decimal: false },
];

const BY_VALUE = Object.fromEntries(CONSUMPTION_UNITS.map((unit) => [unit.value, unit]));

export const consumptionUnitLabel = (unit) => BY_VALUE[unit]?.label ?? "";

// False when the unit is counted and the quantity isn't a whole number
export const unitAcceptsQuantity = (unit, quantity) => !BY_VALUE[unit] || BY_VALUE[unit].decimal || Number.isInteger(quantity);

// Up to 2 decimals, "." as decimal separator
export const formatUnitQuantity = (quantity) => String(Math.round(Number(quantity) * 100) / 100);
